import { Controller } from "react-hook-form";
import { fontSizes } from "../../constants/constants";
import Text from "../Text";
import Functions from "./index.function";
const DefaultValueDropdown = ({
  options = [],
  control,
  name,
  label,
  iconStyle,
  icon,
  valueoption,
  valueName,
  rightIcon,
  isLoadingpreFiled,
  isLoading,
  isMandatory,
  errors,
}) => {
  const {
    dropdownRef,
    TextWeight,
    isOpen,
    setIsOpen,
    toggleDropdown,
    searchTerm,
    setSearchTerm,
    searchInputRef,
    filteredOptions,
  } = Functions(options, valueName);

  return (
    <Controller
      name={name}
      control={control}
      rules={isMandatory ? { required: `${label} is required` } : {}}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const selectedOption = options?.find(
          (option) => String(option[valueoption]) === String(value)
        );
        return (
          <div
            className={`relative ${
              isLoading || isLoadingpreFiled
                ? "opacity-50 cursor-not-allowed"
                : ""
            }`}
            w-full
            ref={dropdownRef}
          >
            {label && (
              <Text
                text={<>{label}</>}
                size={fontSizes.h16}
                weight={TextWeight.Onest_regular}
                isRequired={isMandatory}
                color="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary"
              />
            )}
            <div
              className={`relative xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-3.5 rounded-full text-[#808080] transition duration-300 delay-100 border-2 
                            ${
                              isOpen
                                ? "border-goldMetallic"
                                : "border-transparent"
                            }`}
              onClick={toggleDropdown}
            >
              <div className="flex items-center justify-between">
                {isOpen ? (
                  <input
                    type="text"
                    placeholder="Search..."
                    className="w-full bg-transparent outline-none text-white"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    ref={searchInputRef}
                    autoFocus
                  />
                ) : (
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleDropdown(e);
                    }}
                  >
                    {selectedOption
                      ? selectedOption[valueName]
                      : `Select ${label}`}
                  </span>
                )}
                {icon && (
                  <img
                    className={`absolute left-5 3xl:left-8 top-1/2 transform -translate-y-1/2 ${iconStyle}`}
                    src={icon}
                    alt={`${name} icon`}
                  />
                )}
                <img
                  className="absolute right-5 3xl:top-[30%] xs:top-4 sm:top-4 top-5 3xl:right-8 transform -translate-y-1/2 xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-5 w-6 3xl:w-7 3xl:h-6 transition-transform duration-500"
                  src={rightIcon}
                  alt="Dropdown icon"
                  style={{
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                />
              </div>
            </div>
            {isOpen && (
              <div className="absolute z-10 w-full bg-[#171717] rounded-3xl mt-2 max-h-60 overflow-y-auto scroll-container shadow-lg border-goldMetallic border-2">
                <ul className="text-[#808080]">
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((option, index) => (
                      <li
                        key={option[valueoption]}
                        onClick={() => {
                          onChange(option[valueoption]);
                          setIsOpen(false);
                          setSearchTerm("");
                        }}
                        className={`py-3 relative cursor-pointer transition duration-300 px-4 
                                                ${
                                                  index !==
                                                  filteredOptions.length - 1
                                                    ? "after:absolute after:bottom-0 after:left-4 after:w-11/12 after:h-[2px] after:bg-[#212121]"
                                                    : ""
                                                }`}
                      >
                        {option[valueName]}
                      </li>
                    ))
                  ) : (
                    <li className="py-3 px-4 text-center text-[#808080]">
                      No options found
                    </li>
                  )}
                </ul>
              </div>
            )}

            {errors?.[name] && (
              <Text
                text={errors[name].message}
                color="text-orangeCrayola"
                size={fontSizes.h14}
                textWeight={TextWeight.Onest_regular}
                className={"xs:pl-6 sm:pl-6 lg:pl-8"}
                isTruncate={false}
              />
            )}
          </div>
        );
      }}
    />
  );
};

export default DefaultValueDropdown;
